import { WarningDiamond } from '@phosphor-icons/react';

import { AlertBoxStyled } from './AlertBoxStyled';

interface AlertBoxProps {
  title?: string;
  innerText: string;
}

export const AlertBox = ({ title, innerText }: AlertBoxProps) => {
  return (
    <AlertBoxStyled data-testid="alert-box-container">
      <i className="ph-bold ph-warning-diamond mr-2"></i>
      <div className="text-wrap">
        <div className="body2 semiBold">{title}</div>
        <div className="body2">{innerText}</div>
      </div>
    </AlertBoxStyled>
  );
};
